<section class="page-stack">
  <div class="crud-panel">
    <div class="crud-header">
      <div>
        <span class="eyebrow">msvc-client</span>
        <h2>Client credentials</h2>
      </div>
      <button class="primary-button add-button" type="button" (click)="openCreate()">+ Add New</button>
    </div>

    <div class="crud-tools">
      <input type="search" placeholder="Buscar" [(ngModel)]="searchText" (keyup.enter)="applyFilters()">
      <app-client-select [(ngModel)]="filters['clienteId']"></app-client-select>
      <input type="text" placeholder="Razon social" [(ngModel)]="filters['razonSocial']">
      <input type="number" placeholder="CUIT" [(ngModel)]="filters['cuit']">
      <select [(ngModel)]="filters['enabled']">
        <option value="">Todos</option>
        <option value="true">Activos</option>
        <option value="false">Inactivos</option>
      </select>
      <button class="ghost-button" type="button" (click)="clearFilters()">Limpiar</button>
      <button class="primary-button" type="button" (click)="applyFilters()">Filtrar</button>
    </div>

    <div class="state success-state" *ngIf="message">{{ message }}</div>
    <div class="state error" *ngIf="error">{{ error }}</div>

    <div class="table-wrap">
      <table class="crud-table client-credentials-table">
        <thead>
          <tr>
            <th>Cliente ID</th>
            <th>Razon social</th>
            <th>CUIT</th>
            <th>Cognito client ID</th>
            <th>Estado</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td>{{ row.clienteId || '-' }}</td>
            <td>{{ row.razon_social || '-' }}</td>
            <td>{{ row.cuit || '-' }}</td>
            <td>{{ row.clientId || '-' }}</td>
            <td>
              <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                {{ row.enabled ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>
              <div class="row-actions">
                <button class="action-button edit" type="button" title="Editar" (click)="openEdit(row)">✎</button>
                <button class="action-button delete" type="button" title="Deshabilitar" (click)="disable(row)" [disabled]="!row.enabled">■</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!rows.length && !tableLoading">
            <td colspan="6">Sin resultados</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div class="pagination-status">
        <span class="loading-spinner" *ngIf="tableLoading"></span>
        {{ total }} registros
      </div>
      <label class="inline-control">
        Registros
        <select [(ngModel)]="size" (ngModelChange)="changeSize()">
          <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
        </select>
      </label>
      <div class="pagination-actions">
        <button class="ghost-button" type="button" (click)="changePage(page - 1)" [disabled]="page === 0">Anterior</button>
        <app-page-navigation [page]="page" [totalPages]="totalPages" [disabled]="tableLoading" (pageChange)="changePage($event)"></app-page-navigation>
        <button class="ghost-button" type="button" (click)="changePage(page + 1)" [disabled]="page + 1 >= totalPages">Siguiente</button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="modalOpen">
    <form class="modal credential-modal" (ngSubmit)="save()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditing ? 'Editar' : 'Alta Cognito M2M' }}</span>
          <h3>{{ isEditing ? 'Editar credencial' : 'Nueva credencial' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="credential-form">
        <label>
          Cliente ID
          <app-client-select name="clienteId" [(ngModel)]="form.clienteId" [disabled]="isEditing"></app-client-select>
        </label>
        <label>
          Razon social
          <input type="text" name="razonSocial" [(ngModel)]="form.razonSocial">
        </label>
        <label>
          CUIT
          <input type="number" name="cuit" min="1" [(ngModel)]="form.cuit">
        </label>
      </div>

      <div class="secret-panel" *ngIf="createdSecret">
        <label>
          Client secret
          <input type="text" readonly [value]="createdSecret">
        </label>
        <button class="ghost-button" type="button" (click)="copySecret()">Copiar</button>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSave || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>
</section>
